import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/general/webhooks')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/admin/general/webhooks"!</div>
}
